import { render, staticRenderFns } from "./add_issuable_form.vue?vue&type=template&id=0a035d30&"
import script from "./add_issuable_form.vue?vue&type=script&lang=js&"
export * from "./add_issuable_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports